import { t } from 'i18next';
import CommissionEquation from '../../assets/equations/commission_equation';
import RateEquation from '../../assets/equations/rate_equation';

export const availableFactoringTitles = {
  summaryDataTitle: 'Resumen de tu cotización',
  summaryTableButtonText: 'Agregar más facturas',
  summaryTableButtonTextMobile: 'Agregar o eliminar facturas',
  get summaryDataDisclaimer() {
    return t('summary-data-disclaimer-available-factoring');
  },
  summaryDataInfoTitle: 'Explicación de los costos',
  summaryDataInfoChile: [
    {
      label: 'Monto a financiar',
      value: 'Corresponde al porcentaje del total de la operación que Fingo puede anticipar. El porcentaje restante se asigna como garantía y se libera al momento de recaudar las facturas dentro del plazo acordado.',
    },
    {
      label: 'Diferencia de precio',
      value: 'Corresponde al costo de anticipar el dinero y se calcula según la tasa mensual acordada y los días que faltan para el vencimiento.',
      equation: CommissionEquation,
      alt: 'Formula de diferencia de precio',
      width: 349,
      height: 57,
    },
    {
      label: 'Comisión',
      value: 'Costo asociado a utilizar el servicio de Fingo, varía según el tramo del monto total de la operación. Para conocer los montos exactos según cada tramo, te invitamos a consultar con tu ejecutivo, quien podrá entregarte la información actualizada.',
    },
  ],
  summaryDataInfoMexico: [
    {
      label: 'Monto retenido por aforo',
      value: 'Corresponde al porcentaje del total que se asigna como garantía y se libera al momento de recaudar las facturas dentro del plazo acordado. Este porcentaje parte desde un 20% y puede variar según la línea de crédito disponible.',
    },
    {
      label: 'Interés',
      value: 'Corresponde al costo de anticipar el dinero y se calcula según la tasa mensual acordada y los días que faltan para el vencimiento.',
      equation: RateEquation,
      alt: 'Formula del interés',
      width: 349,
      height: 57,
    },
    {
      label: '',
      value: '',
    },
  ],
};

export const availableOffersTitles = {
  summaryTitle: 'Ingresa la fecha de vencimiento',
  summaryDescription: 'Puedes seleccionar una misma fecha para todo un receptor, o también puedes editar la fecha de cada factura por si sola.',
  summaryDataTitle: 'Resumen de tu operación',
  summaryDataDisclaimer: '',
  summaryActionButtonTextChile: 'Ir a ceder',
  summaryActionButtonTextMexico: 'Ceder derechos de cobro',
  cessionSummaryTitle: 'Cede tus facturas',
  cessionSummaryDescription: 'Estás a solo un paso de financiar tus facturas',
  summaryActionButtonTooltip: 'Seleccione todas las fechas de pago de las ofertas elegidas',
  summaryDataInfoChile: availableFactoringTitles.summaryDataInfoChile,
  summaryDataInfoMexico: availableFactoringTitles.summaryDataInfoMexico,
  summaryDataInfoTitle: availableFactoringTitles.summaryDataInfoTitle,
};
